import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { HelpComponent } from './components/help/help.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

const MAIN_ROUTES: Routes = [
    { path: '', component: HomeComponent, pathMatch: 'full' },
    { path: 'perfil', component: ProfileComponent },
    { path: 'suscripcion', component: SubscriptionComponent },
    { path: 'ayuda', component: HelpComponent },
    { path: 'preguntas-frecuentes', component: FaqsComponent },
    { path: 'terminosycondiciones-pagodirecto', component: TermsAndConditionsComponent }
];
export const CONST_ROUTING = RouterModule.forRoot(MAIN_ROUTES);



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/app.routing.ts